import styled from "styled-components";
  export const Title =styled.h2`
  font-weight:bold;
  margin: 0 0 5px 0 
  `
  export const SubTitle =styled.h5`
  margin: 0 0 5px 0 
  `